import { render } from "./SubirImagen.vue?vue&type=template&id=804e8ba6&scoped=true"
import script from "./SubirImagen.vue?vue&type=script&lang=js"
export * from "./SubirImagen.vue?vue&type=script&lang=js"

import "./SubirImagen.vue?vue&type=style&index=0&id=804e8ba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804e8ba6"]])

export default __exports__